let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6mY9e")).then(() => parcelRequire('2ToVs'));